import React from 'react';
import { getGetMembershipsQueryOptions } from '@area-restrita/api-client/endpoints/memberships/memberships.gen';

import { useQueryTable } from '@/hooks/useQueryTable';
import { useAuthSessionStore } from '@/modules/authentication/stores/authSessionStore';

import { columns } from './columns';
import MembersSettingsView from './view';

const MembersSettings: React.FC = () => {
  const checkAuthorization = useAuthSessionStore(
    (state) => state.checkAuthorization,
  );

  const { query, table } = useQueryTable({
    columns,
    getQueryOptions: getGetMembershipsQueryOptions,
  });

  return (
    <MembersSettingsView
      table={table}
      isLoading={query.isLoading}
      canInvite={checkAuthorization(({ can }) => can('create', 'memberships'))}
    />
  );
};

export default MembersSettings;
